module.exports = __webpack_public_path__ + "img/1+1-Tafel_A0.11779085.png";